import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var InsertMathIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.055 23.2491C43.4707 23.6515 43.4815 24.3147 43.0791 24.7304L29.9909 38.2516C29.5885 38.6673 28.9253 38.6781 28.5096 38.2757C28.0939 37.8733 28.0831 37.2101 28.4855 36.7944L41.5736 23.2732C41.976 22.8574 42.6393 22.8467 43.055 23.2491Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5096 23.2491C28.9253 22.8467 29.5885 22.8574 29.9909 23.2732L43.0791 36.7944C43.4815 37.2101 43.4707 37.8733 43.055 38.2757C42.6393 38.6781 41.976 38.6673 41.5736 38.2516L28.4855 24.7304C28.0831 24.3147 28.0939 23.6515 28.5096 23.2491Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4072 7.88449C20.5699 7.4942 20.9513 7.23999 21.3741 7.23999H44.9524C45.531 7.23999 46 7.70902 46 8.2876C46 8.86618 45.531 9.33522 44.9524 9.33522H22.0724L9.23893 40.1191C9.06756 40.5301 8.65505 40.7879 8.21047 40.7618C7.7659 40.7356 7.38644 40.4313 7.26444 40.003L2.04035 21.6628C1.88185 21.1063 2.20444 20.5267 2.76089 20.3682C3.31734 20.2097 3.89692 20.5323 4.05542 21.0888L8.45839 36.5463L20.4072 7.88449Z"
  }));
});
InsertMathIcon.displayName = 'InsertMathIcon';
InsertMathIcon.defaultProps = {
  'aria-label': 'InsertMath'
};
export default InsertMathIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/InsertMathIcon/index.js
// module id = 1870
// module chunks = 12